import Vue from "vue";
import Router from "vue-router";
const User = () => import("@/pages/user");

const PasswdAccount = () => import("@/pages/user/passwdAccount");

// 新各人中心
const newUser = () => import("@/pages/newuser");
const newPasswdAccount = () => import("@/pages/newuser/newpasswdAccount");

const passwd_account_hor = () => import("@/pages/newuser_hor/passwdAccount");

const Kac = () => import("@/pages/kac");
const KacInput = () => import("@/pages/kac/kacinput.vue");
const Kacsucceed = () => import("@/pages/kac/kacsucceed.vue");
const Hongbao = () => import("@/pages/hongbao");
const newHongbao = () => import("@/pages/hongbao/newhongbao.vue");
const exclusiveRedBag = () => import("@/pages/exclusiveRedBag/index.vue"); // 专属红包
const exclusiveWithdrawal = () =>
  import("@/pages/exclusiveRedBag/withdrawal.vue"); // 专属提现
const withdrawal_log = () =>
  import("@/pages/exclusiveRedBag/withdrawal_log.vue"); // 专属提现记录
const sendRedbag_log = () =>
  import("@/pages/exclusiveRedBag/sendRedbag_log.vue"); // 专属主播发送记录
const withdrawal_Agreement = () =>
  import("@/pages/exclusiveRedBag/withdrawal_Agreement.vue"); // 免责声明

const AnchorPackageLog = () => import("@/pages/hongbao/anchorPackageLog.vue");
const HongbaoH5 = () => import("@/pages/hongbao/hongbaoh5.vue");
const HongbaoH52 = () => import("@/pages/hongbao/hongbaoh5-2.vue");
const Hongbao_top = () => import("@/pages/hongbao/hongbaoh_top.vue"); // 高级红包
const newHongbao_top = () => import("@/pages/hongbao/newhongbaoh_top.vue"); // 新版高级红包

const Fenhongbih5 = () => import("@/pages/fenhongchi/fenhongbih5.vue");
const Fenbiexclusive = () => import("@/pages/fenhongchi/fenbi-exclusive.vue");
const Upgrade = () => import("@/pages/fenhongchi/upgrade.vue"); //升级攻略
const Hehuoren = () => import("@/pages/hehuoren");
const HehuorenGuize = () => import("@/pages/hehuoren/hhrguize.vue");
const Tixianlog = () => import("@/pages/hongbao/tixianlog.vue");
const Tixianpage = () => import("@/pages/hongbao/tixianpage.vue");
const Tixianpage1 = () => import("@/pages/hongbao/tixianpage1.vue");

const Fahongbao = () => import("@/pages/hongbao/Fahongbao.vue"); //添加发红包
const Member = () => import("@/pages/member"); //会员

const Zhibo = () => import("@/pages/zhiboHongbao"); //直播红包
const ZhiboNew = () => import("@/pages/zhiboHongbao/zhiboHongBaoNew.vue"); //新版直播红包
const HongbaoDetail = () => import("@/pages/zhiboHongbao/hongbaoDetail.vue"); //直播红包领取详情
const signin = () => import("@/pages/signin/index.vue"); // 签到页面
const newsignin = () => import("@/pages/newsignin/index.vue"); // 新版签到页面
const luckDraw = () => import("@/pages/signin/luckDraw.vue"); // 签到抽奖页面
const newluckDraw = () => import("@/pages/newsignin/luckDraw.vue"); // 新签到抽奖页面
const ipadLuckdraw = () => import("@/pages/ipadLuckdraw/index.vue"); // ipad抽奖活动
const excitation = () => import("@/pages/excitation/index.vue"); // 激励金

const mainbox = () => import("@/components/main/index.vue"); // 侧滑栏模版
const baZhu = () => import("@/pages/bazhu"); //霸主
const currency = () => import("@/pages/currency"); //平台币
const privilege = () => import("@/pages/privilege"); //特权中心
const inviteFriends = () => import("@/pages/inviteFriend"); //邀请好友
const newinvitation = () => import("@/pages/new_invitteFriend"); //邀请好友
// import inviteFriends from "@/pages/inviteFriend" //邀请好友
const turntable = () => import("@/pages/turntable");
const giftHeaven = () => import("@/pages/giftHeaven");
const limitHongbao = () => import("@/pages/hongbao/limithongbao"); //限时红包
const UpCard = () => import("@/pages/UpCard"); //限时红包
const nodata = () => import("@/components/main/no_data.vue"); //404无数据
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/", // 默认进入路由
      component: mainbox
      // redirect: '/kac' //重定向
    },
    {
      path: "/user",
      name: "User",
      component: User,
      meta: {
        title: "用户中心",
        index: 0
      }
    },
    {
      path: "/newuser",
      name: "newUser",
      component: newUser,
      meta: {
        title: "用户中心",
        index: 0
      }
    },
    {
      path: "/newpasswd_account",
      name: "newPasswdAccount",
      component: newPasswdAccount,
      meta: {
        title: "账号修改密码",
        index: 100
      }
    },
    {
      path: "/passwd_account_hor",
      name: "passwd_account_hor",
      component: passwd_account_hor,
      meta: {
        title: "账号修改密码"
        // index: 100
      }
    },
    {
      path: "/kac",
      name: "Kac",
      component: Kac,
      meta: {
        title: "礼包",
        index: 2
      }
    },
    {
      path: "/kacinput",
      name: "kacinput",
      component: KacInput,
      meta: {
        title: "礼包输入",
        index: 100
      }
    },
    {
      path: "/kacsucceed/:code",
      name: "kacsucceed",
      component: Kacsucceed,
      meta: {
        title: "礼包码",
        index: 100
      }
    },
    {
      path: "/hongbao",
      name: "Hongbao",
      component: Hongbao,
      meta: {
        title: "红包",
        index: 6
      }
    },
    {
      path: "/anchorPackageLog",
      name: "AnchorPackageLog",
      component: AnchorPackageLog,
      meta: {
        title: "主播红包领取记录",
        index: 100
      }
    },
    {
      path: "/hongbaoh5",
      name: "Hongbaoh5",
      component: HongbaoH5,
      meta: {
        title: "红包",
        index: 9
      }
    },
    {
      path: "/hongbaoh5_2_v2",
      name: "Hongbaoh5_2_v2",
      component: () => import("@/pages/hongbao/hongbaoh5-2_v2.vue"),
      meta: {
        title: "红包",
        index: 112
      }
    },
    {
      path: "/hongbaoh5_2",
      name: "Hongbaoh5_2",
      component: HongbaoH52,
      meta: {
        title: "红包",
        index: 10
      }
    },
    {
      path: "/fenbi-exclusive",
      name: "Fenbi-exclusive",
      component: Fenbiexclusive,
      meta: {
        title: "专属红币",
        index: 12
      }
    },
    {
      path: "/upgrade",
      name: "upgrade",
      component: Upgrade,
      meta: {
        title: "升级攻略"
      }
    },

    {
      path: "/fenhongbih5",
      name: "Fenhongbih5",
      component: Fenhongbih5,
      meta: {
        title: "分红币",
        index: 11
      }
    },
    {
      path: "/hehuoren",
      name: "Hehuoren",
      component: Hehuoren,
      meta: {
        title: "领军人",
        index: 7
      }
    },
    {
      path: "/bazhu",
      name: "BaZhu",
      component: baZhu,
      meta: {
        title: "霸主",
        index: 107
      }
    },
    {
      path: "/currency",
      name: "Currency",
      component: currency,
      meta: {
        title: "平台币",
        index: 108
      }
    },
    {
      path: "/hhrguize",
      name: "HehuorenGuize",
      component: HehuorenGuize,
      meta: {
        title: "领军人规则",
        index: 100
      }
    },
    {
      path: "/passwd_account",
      name: "PasswdAccount",
      component: PasswdAccount,
      meta: {
        title: "账号修改密码",
        index: 100
      }
    },
    {
      path: "/tixianlog/:tixianType",
      name: "Tixianlog",
      component: Tixianlog,
      meta: {
        title: "提现记录",
        index: 100
      }
    },
    {
      path: "/tixianpage/:tixianType",
      name: "Tixianpage",
      component: Tixianpage,
      meta: {
        title: "提现",
        index: 100
      }
    },
    {
      path: "/tixianpage1/:tixianType",
      name: "Tixianpage1",
      component: Tixianpage1,
      meta: {
        title: "提现",
        index: 100
      }
    },
    {
      path: "/fahongbao",
      name: "FaHongbao",
      component: Fahongbao, //发红包
      meta: {
        title: "发红包",
        index: 100
      }
    },
    {
      path: "/member",
      name: "Member",
      component: Member,
      meta: {
        title: "会员",
        index: 8
      }
    },
    {
      path: "/zhiboHongbao",
      name: "ZhiboHongbao",
      component: Zhibo,
      meta: {
        title: "直播红包",
        index: 61
      }
    },
    {
      path: "/zhiboHongbaoNew",
      name: "ZhiboHongbaoNew",
      component: ZhiboNew,
      meta: {
        title: "直播红包", //新版
        index: 610
      }
    },
    {
      path: "/hongbaoDetail",
      name: "HongbaoDetail",
      component: HongbaoDetail,
      meta: {
        title: "直播红包详情",
        index: 62
      }
    },
    {
      path: "/newHongbao",
      name: "newHongbao",
      component: newHongbao,
      meta: {
        title: "等级红包",
        index: 68
      }
    },
    //  {
    //     path: '/xianzhi',
    //     name: 'xianzhi',
    //     component: () => import('@/pages/xianzhi/indexold.vue'),
    //     meta: {
    //       title: '闲置',
    //       index: 76
    //     }
    //   },
    // {
    //   path: '/newsignin',
    //   name: 'newsignin',
    //   component: newsignin,
    //   meta: {
    //     title: '签到',
    //     index: 63
    //   }
    // },
    {
      path: "/mainbox",
      name: "mainbox",
      component: mainbox,
      redirect: "/signin",
      meta: {
        title: "侧滑栏模版",
        index: 666
      },
      children: [
        {
          path: "/signin",
          name: "signin",
          component: signin,
          meta: {
            title: "签到",
            index: 63
          }
        },
        {
          path: "/Hongbao_top_v2",
          name: "Hongbao_top_v2",
          component: () => import("@/pages/hongbao/hongbaoh_top_v2.vue"),
          meta: {
            title: "高级红包",
            index: 114
          }
        },
        {
          path: "/Hongbao_top",
          name: "Hongbao_top",
          component: Hongbao_top,
          meta: {
            title: "高级红包",
            index: 67
          }
        },
        {
          path: "/newHongbao_top_v2",
          name: "newHongbao_top_v2",
          component: () => import("@/pages/hongbao/newhongbaoh_top_v2.vue"),
          meta: {
            title: "高级红包",
            index: 113
          }
        },

        {
          path: "/newHongbao_top",
          name: "newHongbao_top",
          component: newHongbao_top,
          meta: {
            title: "高级红包",
            index: 67
          }
        },
        {
          path: "/vipcenter",
          name: "vipcenter",
          component: () => import("@/pages/vipcenter/index.vue"),
          meta: {
            title: "会员中心",
            index: 145
          }
        }, {
          path: "/Redechange",
          name: "Redechange",
          component: () => import("@/pages/Redechange/index.vue"),
          meta: {
            title: "兑换会员",
            index: 146
          }
        },
        {
          path: "/exclusiveRedBag",
          name: "exclusiveRedBag",
          component: exclusiveRedBag,
          meta: {
            title: "专属红包",
            index: 69
          }
        },
        {
          path: "/exclusive_withdrawal",
          name: "exclusiveWithdrawal",
          component: exclusiveWithdrawal,
          meta: {
            title: "专属红包提现",
            index: 69
          }
        },
        {
          path: "/withdrawal_log",
          name: "withdrawal_log",
          component: withdrawal_log,
          meta: {
            title: "专属红包提现记录",
            index: 69
          }
        },
        {
          path: "/sendRedbag_log",
          name: "sendRedbag_log",
          component: sendRedbag_log,
          meta: {
            title: "专属红包主播发送记录",
            index: 69
          }
        },
        {
          path: "/withdrawal_Agreement",
          name: "withdrawal_Agreement",
          component: withdrawal_Agreement,
          meta: {
            title: "专属红包免责声明",
            index: 69
          }
        },
        {
          path: "/ipadLuckdraw",
          name: "ipadLuckdraw",
          component: ipadLuckdraw,
          meta: {
            title: "幸运抽奖",
            index: 72
          }
        },
        {
          path: "/excitation",
          name: "excitation",
          component: excitation,
          meta: {
            title: "激励金",
            index: 73
          }
        },
        {
          path: "/tickets",
          name: "tickets",
          component: () => import("@/pages/tickets/index.vue"),
          meta: {
            title: "点劵钱包",
            index: 75
          }
        },
        {
          path: "/xianzhi",
          name: "xianzhi",
          component: () => import("@/pages/xianzhi/oldindex.vue"),
          meta: {
            title: "闲置",
            index: 76
          }
        },
        {
          path: "/superPlayer",
          name: "superPlayer",
          component: () => import("@/pages/superPlayer/index.vue"),
          meta: {
            title: "超级玩家",
            index: 116
          }
        },
        {
          path: "/oldsuperPlayer",
          name: "oldsuperPlayer",
          component: () => import("@/pages/superPlayer/oldindex.vue"),
          meta: {
            title: "超级玩家",
            index: 130
          }
        },
        {
          path: "/district",
          name: "district",
          component: () => import("@/pages/district/index.vue"),
          meta: {
            title: "区长",
            index: 117
          }
        },{
          path: "/district-qrzs",
          name: "district-qrzs",
          component: () => import("@/pages/district/index-qrzs.vue"),
          meta: {
            title: "区长",
            index: 129
          }
        },
        {
          path: "/newdistrict",
          name: "newdistrict",
          component: () => import("@/pages/newdistrict/index.vue"),
          meta: {
            title: "区长",
            index: 128
          }
        },
        {
          path: "/hor_redbag",
          name: "hor_redbag",
          component: () => import("@/pages/hor_redbag/index.vue"),
          meta: {
            title: "横版红包",
            index: 118
          }
        },
        {
          path: "/hor_superPlayer",
          name: "hor_superPlayer",
          component: () => import("@/pages/hor_superPlayer/index.vue"),
          meta: {
            title: "横版超级玩家",
            index: 119
          }
        },
        {
          path: "/newuser_hor",
          name: "newuser_hor",
          component: () => import("@/pages/newuser_hor/index.vue"),
          meta: {
            title: "横版我的",
            index: 120
          }
        },
        {
          path: "/currency_hor",
          name: "currency_hor",
          component: () => import("@/pages/currency_hor/index.vue"),
          meta: {
            title: "横版平台币",
            index: 121
          }
        },
        {
          path: "/complaint",
          name: "complaint",
          component: () => import("@/pages/complaint/index.vue"),
          meta: {
            title: "客服/投诉",
            index: 122
          }
        },{
          path: "/vipcenter",
          name: "vipcenter",
          component: () => import("@/pages/vipcenter/index.vue"),
          meta: {
            title: "会员中心",
            index: 145
          }
        },
        {
          path: "/aibox",
          name: "aibox",
          component: () => import("@/pages/ai/index.vue"),
          meta: {
            title: "ai52",
            index: 123
          }
        },
        {
          path: "/aibox_hor",
          name: "aibox_hor",
          component: () => import("@/pages/ai/hor_index.vue"),
          meta: {
            title: "ai52",
            index: 124
          }
        },
        {
          path: "/recycling_hor",
          name: "recycling_hor",
          component: () => import("@/pages/recycling_hor/index.vue"),
          meta: {
            title: "装备回收",
            index: 125
          }
        },
        {
          path: "/UpCard",
          name: "UpCard",
          component: UpCard,
          meta: {
            title: "UP 卡",
            index: 126
          }
        },
        {
          path: "/newvip",
          name: "newvip",
          component: () => import("@/pages/newvip/index.vue"),
          meta: {
            title: "福利中心",
            index: 127
          }
        },
        {
          path: "/newvip/details",
          name: "newvip_details",
          component: () => import("@/pages/newvip/shopdetails.vue"),
          meta: {
            title: "福利中心",
            index: 127
          }
        },
        {
          path: "/newvip/allorder",
          name: "newvip_allorder",
          component: () => import("@/pages/newvip/allorder.vue"),
          meta: {
            title: "福利中心",
            index: 127
          }
        },
        {
          path: "/newvip/harvest",
          name: "newvip_harvest",
          component: () => import("@/pages/newvip/harvest.vue"),
          meta: {
            title: "福利中心",
            index: 127
          }
        },
        {
          path: "/newvip/address",
          name: "newvip_address",
          component: () => import("@/pages/newvip/address.vue"),
          meta: {
            title: "福利中心",
            index: 127
          }
        },
        {
          path: "/exclusiveGift",
          name: "exclusiveGift",
          component: () => import("@/pages/exclusiveGift/index.vue"),
          meta: {
            title: "专属福利",
            index: 140
          }
        },
        {
          path: "/404",
          name: "404",
          component: nodata,
          meta: {
            title: "404"
          }
        }
      ]
    },
    {
      path: "/tickets_log",
      name: "tickets_log",
      component: () => import("@/pages/tickets/tickets_log.vue"),
      meta: {
        title: "点劵钱包",
        index: 75
      }
    },
    {
      path: "/comInvitteFriend",
      name: "comInvitteFriend",
      component: () => import("@/pages/com_invitteFriend/index.vue"),
      meta: {
        title: "邀请好友",
        index: 115
      }
    },
    {
      path: "/privilege",
      name: "privilege",
      component: privilege,
      meta: {
        title: "特权中心",
        index: 70
      }
    },
    {
      path: "/newsignin",
      name: "newsignin",
      component: newsignin,
      meta: {
        title: "签到",
        index: 63
      }
    },
    {
      path: "/luckDraw",
      name: "luckDraw",
      component: luckDraw,
      meta: {
        title: "签到抽奖页面",
        index: 64
      }
    },
    {
      path: "/newluckDraw",
      name: "newluckDraw",
      component: newluckDraw,
      meta: {
        title: "签到抽奖页面",
        index: 64
      }
    },
    {
      path: "/inviteFriends",
      name: "inviteFriends",
      component: inviteFriends,
      meta: {
        title: "邀请好友",
        index: 63
      }
    },
    {
      path: "/invitation",
      name: "Invitation",
      component: () => import("@/pages/invitation2/index.vue"),
      meta: {
        title: "邀请好友",
        index: 105
      }
    },
    {
      path: "/invitation/withdrawal",
      name: "InvitationWithdrawal",
      component: () => import("@/pages/invitation/withdrawal.vue"),
      meta: {
        title: "邀请好友提现",
        index: 106
      }
    },
    {
      path: "/newinvitation",
      name: "newinvitation",
      component: newinvitation,
      meta: {
        title: "邀请好友",
        index: 105
      }
    },

    {
      path: "/turntable",
      name: "turntable",
      component: turntable,
      meta: {
        title: "转盘抽奖",
        index: 74
      }
    },
    {
      path: "/giftHeaven",
      name: "giftHeaven",
      component: giftHeaven,
      meta: {
        title: "天降豪礼",
        index: 101
      }
    },
    // 限时红包
    {
      path: "/limitHongbao",
      name: "limitHongbao",
      component: limitHongbao,
      meta: {
        title: "限时红包",
        index: 102
      }
    },
    {
      path: "/hongbao_new",
      name: "hongbao_new",
      component: () => import("@/pages/newhongbao/index.vue"),
      meta: {
        title: "红包",
        index: 103
      }
    },
    {
      path: "/hongbao_new_xiuluo",
      name: "hongbao_new_xiuluo",
      component: () => import("@/pages/newhongbao/index-xiuluo.vue"),
      meta: {
        title: "修罗",//新版本集成红包
        index: 104
      }
    }
    // {
    //     path: '**', // 错误路由
    //     redirect: '/kac' //重定向
    // }
  ]
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(loca, addsearch = true) {
  if (addsearch) {
    loca.path = loca.path + location.search;
  }
  console.log(loca.path);
  return originalPush.call(this, loca).catch(err => err);
};

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js